/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPageStructure = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M8 2v2h2.17a3.003 3.003 0 0 1 2.654-1.995L13 2a3 3 0 1 1-2.829 4H8v2H6v3h2v2h8.17a3.003 3.003 0 0 1 2.654-1.995L19 11a3 3 0 1 1-2.829 4H13v5h6v2h-8v-7H8v2H2v-6h2V8H2V2zM6 13H4v2h2zm13 0a1 1 0 1 0 .001 2.001A1 1 0 0 0 19 13zM6 4H4v2h2zm7 0a1 1 0 1 0 .001 2.001A1 1 0 0 0 13 4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPageStructure as PageStructure };
